var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":_vm.url,"show-file-list":_vm.showFileList,"on-success":_vm.handleAvatarSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeAvatarUpload,"headers":_vm.uploadHeader(),"multiple":false,"on-exceed":_vm.handleExceed,"accept":_vm.accept,"data":_vm.data}},[_vm._t("uploadContent")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }